import React, { useRef } from "react";

const Custom = ({ url, autoplay, previewUrl, visibility = false }) => {
  const vedioRef = useRef(null);

  return (
    <div className="player__wrapper">
      <div className="player__video">
        <video
          ref={vedioRef}
          width="620"
          autoPlay={autoplay}
          controls
          muted={autoplay && !visibility}
          poster={autoplay ? "" : previewUrl}
        >
          <source src={url} type="video/ogg" />
          <source src={url} type="video/webM" />
          <source src={url} type="video/mp4" />
        </video>
      </div>
    </div>
  );
};

export default Custom;
